<template>
  <div class="live">
    <div class="title">
      <h3 @click="quit">
        <i class="el-icon-arrow-left">
          {{
            ids
              ? flag == 0 || flag == 2
                ? $t("live.liveView")
                : $t("live.liveEdit")
              : $t("homepage.addlive")
          }}</i
        >
        <span
          >{{ $t("common.required1") }}<i>*</i
          >{{ $t("common.required2") }}</span
        >
      </h3>
    </div>
    <div class="tixing">
      <h4>{{ $t("common.importantremind") }}</h4>
      <p>
        <!-- 建议您在<i>2023年10月20日</i>前完成资料填写及上传。产品资料愈丰富，曝光机会愈多。
         -->
        {{ $t("common.suggest1") }}<i>{{ $t("live.liveDate") }}</i
        >{{ $t("common.suggest3") }}
      </p>
    </div>
    <!-- 表单元素-------------------------- -->
    <div class="formdata">
      <el-form
        ref="form"
        :model="sizeForm"
        label-width="250px"
        size="mini"
        :rules="rules"
        :disabled="flag === '2' || flag === '0'"
      >
        <el-form-item :label="$t('live.liveNameCh') + ':'" prop="liveCn">
          <el-input
            v-model="sizeForm.liveCn"
            :placeholder="$t('live.placeholder')"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('live.liveNameEn') + ':'">
          <el-input
            v-model="sizeForm.liveEn"
            :placeholder="$t('live.placeholder')"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>

        <!-- 开始时间 -->
        <el-form-item :label="$t('common.startdate') + ':'" prop="startDate">
          <div class="begin">
            <!--  时间日期选择器 -->
            <el-date-picker
              v-model="dateTime.beginyear"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.startdate')"
              :picker-options="pickerOptions"
              @focus="clickStartTime"
            >
            </el-date-picker>

            <el-select
              v-model="dateTime.beginHour"
              :placeholder="$t('common.select')"
            >
              <el-option
                v-for="item in dateTime.beginTimeHour"
                :key="item.value"
                :disabled="item.disabled"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span class="mao">:</span>
            <el-select
              v-model="dateTime.beginSecond"
              :placeholder="$t('common.select')"
            >
              <el-option
                v-for="item in dateTime.beginTimeMinute"
                :key="item.value"
                :disabled="item.disabled"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>

        <!-- 结束时间 -->
        <el-form-item :label="$t('common.enddate') + ':'">
          <div class="begin">
            <!--  时间日期选择器 -->
            <el-date-picker
              v-model="dateTime.endyear"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.select')"
              @focus="clickEndTime"
              :picker-options="endTimeOptions"
            >
            </el-date-picker>

            <el-select
              v-model="dateTime.endHour"
              :placeholder="$t('common.select')"
            >
              <el-option
                v-for="item in dateTime.beginTimeHour"
                :key="item.value"
                :disabled="item.disabled"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span class="mao">:</span>
            <el-select
              v-model="dateTime.endSecond"
              :placeholder="$t('common.select')"
            >
              <el-option
                v-for="item in dateTime.beginTimeMinute"
                :key="item.value"
                :disabled="item.disabled"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>

        <!-- upload新增 -->
        <el-form-item :label="$t('live.uploadimg1') + ':'" prop="coverPhoto">
          <!-- 上传封面部分 -->
          <div class="upload-logo coverImg" @click.stop>
            <div
              :style="{
                background:
                  'url(' +
                  spliceUrl(sizeForm.coverPhoto) +
                  ')#f1f1f1 no-repeat center  /contain',
              }"
              class="upload-logo"
            >
              <img
                alt="删除"
                src="../../../static/icon_del.png"
                @click="deleteImg('coverImg')"
                v-if="flag === '' || flag === '-1'"
              />
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="imgbaseUrl + '/hz/frontCommon/upload'"
                :headers="getToken()"
                :on-error="handleError"
                :on-success="handleSuccess"
                :show-file-list="false"
                :before-upload="
                  (file) => {
                    return coverBefore(file);
                  }
                "
              >
                <div
                  class="el-upload__text"
                  v-if="flag === '' || flag === '-1'"
                >
                  {{ $t("common.selectfile") }}
                </div>
              </el-upload>
            </div>
          </div>

          <!-- 上传封面部分 -->
          <p class="tishi">
            {{
              $t("common.uploadimg1", {
                format: "jpg, png, gif",
                recomsize: "693*399",
                filesize: "500kb",
              })
            }}
          </p>
        </el-form-item>

        <!-- upload新增 -->
        <el-form-item
          :label="$t('live.vedioType') + ':'"
          prop="videoType"
          class="ceshi"
        >
          <el-row style="border: 1px soild red">
            <el-radio v-model="sizeForm.videoType" label="1">
              {{ $t("live.uploadvideo") }}</el-radio
            >
            <el-radio v-model="sizeForm.videoType" label="2">{{
              $t("live.liveLink")
            }}</el-radio>
            <el-radio v-model="sizeForm.videoType" label="3">{{
              $t("live.liveQcrod")
            }}</el-radio>
          </el-row>

          <!-- 上传视频 -->
          <div v-if="sizeForm.videoType == 1">
            <div class="videotype">
              <el-upload
                :action="imgbaseUrl + '/hz/frontCommon/upload'"
                :before-upload="videobeforeUpload"
                :file-list="fileList"
                :headers="getToken()"
                :on-error="handleError"
                :on-remove="removeVideo"
                :on-preview="playVideo"
                :on-success="handlevideotypeAddress"
                :limit="1"
                ref="uploadVideo"
                name="file"
              >
                <i class="select">{{ $t("common.selectfile") }}</i>
                <!-- <p>格式：mp4, mov; 大小：100M内</p> -->
                <p>
                  {{
                    $t("common.uploadvideo2", {
                      format: "mp4, mov",
                      filesize: "100M",
                    })
                  }}
                </p>
              </el-upload>
              <p>{{ $t("common.tips") }}</p>
            </div>
          </div>

          <!-- 直播外链地址 -->
          <el-row>
            <el-input
              v-if="sizeForm.videoType == 2"
              v-model="linktypeAddress"
              :placeholder="$t('live.placeholder1')"
            ></el-input>
          </el-row>

          <!-- 直播入口二维码 -->
          <div class="upload-logo qrcode" v-if="sizeForm.videoType == 3">
            <div
              :style="{
                background:
                  'url(' +
                  spliceUrl(qrtypeAddress) +
                  ')#f1f1f1 no-repeat center  /contain',
              }"
              class="upload-logo qrcode"
            >
              <img
                alt="删除"
                src="../../../static/icon_del.png"
                @click="deleteImg('qr')"
                v-if="flag === '' || flag === '-1'"
              />
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="imgbaseUrl + '/hz/frontCommon/upload'"
                :headers="getToken()"
                name="file"
                :on-error="QrError"
                :on-success="QrSuccess"
                :show-file-list="false"
                :before-upload="
                  (file) => {
                    return QrFormat(file);
                  }
                "
              >
                <div
                  class="el-upload__text"
                  v-if="flag === '' || flag === '-1'"
                >
                  {{ $t("common.selectfile") }}
                </div>
              </el-upload>
            </div>
          </div>
        </el-form-item>

        <!--------------------直播简介------------------------->
        <el-form-item
          :label="$t('live.liveIntroCh') + ':'"
          prop="liveIntroductionCn"
        >
          <div class="tinymced" v-show="flag === '2' || flag === '0'"></div>
          <tinymce
            ref="tinymceCh"
            :data="sizeForm.liveIntroductionCn"
            style="width: 800px"
          ></tinymce>
        </el-form-item>

        <!--------------------直播简介------------------------->
        <el-form-item :label="$t('live.liveIntroEn') + ':'">
          <div class="tinymced" v-show="flag === '2' || flag === '0'"></div>
          <tinymce
            ref="tinymceEn"
            :data="sizeForm.liveIntroductionEn"
            style="width: 800px"
          ></tinymce>
        </el-form-item>

        <!--        <el-button type="primary" class="button" :disabled="sizeForm.auditFlag ? true : false" @click="submitForm(sizeForm)">{{-->
        <!--          sizeForm.auditFlag ? sizeForm.auditFlag : '提交'-->
        <!--        }}</el-button>-->
        <!-- 审核中 -->
        <el-button type="primary" class="button" v-if="flag === '2'">{{
          $t("active.inreview")
        }}</el-button>
        <!--审核一通过  -->
        <el-button type="primary" class="button" v-if="flag === '0'">{{
          $t("active.approve")
        }}</el-button>
        <el-button
          type="primary"
          class="button"
          @click="submitForm(sizeForm)"
          v-if="flag === '' || flag === '-1'"
          >{{ $t("common.submit") }}</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import tinymce from "../../comment/tinymce.vue";
import tinymce2 from "../../comment/tinymce.vue";
import { addLive, getexhdeta } from "../../../../api/live.js"; //导入新增接口
import { forMat, intercept } from "../../../../utils/common.js";

export default {
  name: "addExhiLive",

  components: {
    tinymce,
    tinymce2,
  },
  data() {
    var validatorStartTime = (rule, value, callback) => {
      if (
        !this.dateTime.beginyear &&
        !this.dateTime.beginHour &&
        !this.dateTime.beginSecond
      ) {
        callback(new Error(this.$t("live.liveRules.tishi1")));
      } else {
        callback();
      }
    };

    var validatorLiveIntroductionCn = (rule, value, callback) => {
      const content = this.$refs.tinymceCh.getContent();
      if (!content) {
        callback(new Error(this.$t("live.liveRules.tishi2")));
      } else {
        callback();
      }
    };

    var validatorLiveCoverPhoto = (rule, value, callback) => {
      const content = this.sizeForm.coverPhoto;
      if (!content) {
        callback(new Error(this.$t("live.liveRules.tishi3")));
      } else {
        callback();
      }
    };

    var validatorLiveType = (rule, value, callback) => {
      const type = this.sizeForm.videoType;
      console.log(type === "1");
      if (type === "1") {
        const content = this.videotypeAddress;
        if (!content) {
          this.videotypeAddress = "";
          callback(new Error(this.$t("live.liveRules.tishi4")));
        }
      }
      if (type === "2") {
        const content = this.linktypeAddress;
        if (!content) {
          callback(new Error(this.$t("live.liveRules.tishi5")));
        } else if (content.substr(0, 4) !== "http") {
          callback(new Error(this.$t("live.liveRules.tishi7")));
        }
      }
      if (type === "3") {
        const content = this.qrtypeAddress;
        if (!content) {
          callback(new Error(this.$t("live.liveRules.tishi6")));
        }
      }
      callback();
    };

    return {
      fileList: [],
      videotypeAddress: "", //上传视频
      qrtypeAddress: "", //上传二维码
      linktypeAddress: "", //上传外链
      imgbaseUrl: "",
      id: "1100010022", //直播ID
      auditFlag: false, //审核状态
      sizeForm: {
        liveCn: "", //直播中文名
        liveEn: "", //英文名字
        startDate: "", //开始时间
        endDate: "", //结束时间
        coverPhoto: "", //封面图片
        videoType: "1", //视频类型
        videoAddress: "", //视频地址
        liveIntroductionCn: "", //	直播简介-中
        liveIntroductionEn: "", //直播简介-英文
      },
      // imgArr: ["120", "000"], //查看上传的图片列表
      flag: "",
      videoType: "",
      //时间日期格式
      dateTime: {
        beginyear: "",
        beginHour: "",
        beginSecond: "",
        endyear: "",
        endHour: "",
        endSecond: "",
        beginTimeHour: [],
        beginTimeMinute: [],
      },
      //日期选择器
      rules: {
        liveCn: [
          {
            required: true,
            message: this.$t("live.liveRules.tishi8"),
            trigger: "blur",
          },
        ],
        startDate: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("live.liveRules.tishi9"),
          },
          { validator: validatorStartTime },
        ],
        videoType: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("live.liveRules.tishi10"),
          },
          { validator: validatorLiveType },
        ],
        liveIntroductionCn: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("live.liveRules.tishi11"),
          },
          { validator: validatorLiveIntroductionCn },
        ],
        coverPhoto: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("live.liveRules.tishi12"),
          },
          { validator: validatorLiveCoverPhoto },
        ],
      },
      ids: this.$route.query.data,

      //规则限制，不可选择今天之前的时间日期
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() <= new Date().getTime() - 86400000;
        },
      },

      startTimeOptions: {}, //开始时间
      endTimeOptions: {}, //结束时间
    };
  },

  methods: {
    //返回的url
    spliceUrl(img) {
      if (img.indexOf("http") == -1) {
        img = this.imgbaseUrl + img;
      }
      return img;
    },
    //清空活动视频内容
    removeVideo() {
      this.$refs.uploadVideo.clearFiles();
      this.sizeForm.videotypeAddress = "";
      this.fileList = [];
    },

    //获取token
    getToken() {
      const a = localStorage.getItem("token");
      let token = {};
      token.token = a;
      return token;
    },

    //提交函数
    async add(addData) {
      addData.endDate.length == 2 ? (addData.endDate = "") : "";

      let { data } = await addLive(addData);
      if (data.code == 200) {
        //判断当前的对象是否具有I
        this.sizeForm.hasOwnProperty("id")
          ? this.$message({ message: "直播编辑成功!", type: "success" })
          : this.$message({ message: "新增直播成功!", type: "success" });
        this.$router.push({ name: "exhiLive" });
      }
    },

    //提交函数
    submitForm() {
      this.forMatDate(); //时间日期整合
      const Ch = this.$refs.tinymceCh.getContent(); //获取富文本的内容
      const En = this.$refs.tinymceEn.getContent(); //获取富文本的内容
      this.sizeForm.liveIntroductionCn = Ch;
      this.sizeForm.liveIntroductionEn = En;
      this.sizeForm.videoType == 1 &&
        (this.sizeForm.videoAddress = this.videotypeAddress);
      this.sizeForm.videoType == 2 &&
        (this.sizeForm.videoAddress = this.linktypeAddress);
      this.sizeForm.videoType == 3 &&
        (this.sizeForm.videoAddress = this.qrtypeAddress);
      // this.sizeForm.videoType = Number(this.sizeForm.videoType); //拿到视频类型
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.add(this.sizeForm); //调用接口进行调试
        } else {
        }
      });
    },

    //封面信息提示
    coverBefore(file) {
      const size = file.size / 1024 < 500;
      if (!size) {
        this.$message({ message: "封面图片不能大于500kb!", type: "warning" });
        return false;
      }

      //截取文件名
      // const isJPG = file.type === "image/jpg";
      // const isPNG = file.type === "image/png";
      // const isGif = file.type === "image/gif";

      // if (!isJPG) {
      //   this.$message.error("上传图片的格式只能是JPG、PNG或gif格式!");
      // }
      // if (!isPNG) {
      //   this.$message.error("上传图片的格式只能是JPG、PNG或gif格式!");
      // }
      // if (!isGif) {
      //   this.$message.error("上传图片的格式只能是JPG、PNG或gif格式!");
      // }
      // const isSize = new Promise(function(resolve, reject) {
      //   let width = 300;
      //   let height = 300;
      //   let _URL = window.URL || window.webkitURL;
      //   let img = new Image();
      //   img.onload = function() {
      //     let valid = img.width == width && img.height == height;
      //     valid ? resolve() : reject();
      //   };
      //   img.src = _URL.createObjectURL(file);}).then(() => {return file;},() => { this.$message.error("建议是上传的图片尺寸300px*300px");return Promise.reject();}
      // );
    },
    //二维码图片大小提示消息
    /*
     qrcode(file,volume){
        const bulk = volume;
      const size = file.size / 1024 / 1024;
      if (bulk <= size) {
        this.$message({ message: "封面图片不能大于2M!", type: "warning" });
        return false;

      }

       const isSize = new Promise(function(resolve, reject) {
        let width = 300;
        let height = 300;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
        }).then(() => {return file;},() => { this.$message.error("建议是上传的图片尺寸300px*300px");return Promise.reject();}
      );

     },
     */

    //封面图片上传
    handleSuccess(file) {
      file.code == 200 ? (this.sizeForm.coverPhoto = file.data.url) : "";
    },
    //封面图片上传失败
    // handleError() {
    //   console.log('上传失败！');
    // },

    //删除图片
    deleteImg(arg) {
      arg == "coverImg" ? (this.sizeForm.coverPhoto = "") : "";
      arg == "coverVideoType" ? (this.sizeForm.videoAddress = "") : "";
      arg == "qr" ? (this.qrtypeAddress = "") : "";
    },

    handleError(file) {
      console.log(file, "封面上传失败");
    },

    // //视频上传检测类型和大小
    // handleBefore(file, type, typeOne, volume) {
    //   // console.log(file, type, typeOne, volume);
    //
    //   const fileType = type; //类型一 mp4
    //   const fileTypeOne = typeOne; //类型二 mov
    //   const bulk = volume; //体积检测
    //
    //   const videType = file.name.substring(file.name.lastIndexOf('.') + 1);
    //   // console.log("截取的视频后缀名是：", videType);
    //   const size = parseInt(file.size / 1024 / 1024);
    //
    //   //把size进行取整
    //   // console.log("视频体积是：", size, "目标文件体积是", bulk);
    //
    //   if (size >= bulk) {
    //     this.$message({ message: '视频体积不能大于100Mb!', type: 'warning' });
    //   }
    //   if (String(videType) != String(fileTypeOne) && String(videType) != String(fileType)) {
    //     this.$message({
    //       message: '视频格式只能是' + fileType + '或者' + fileTypeOne + '格式!',
    //       type: 'warning',
    //     });
    //   }
    // },
    // //视频成功后
    // uploadVideoSuccess(file) {
    //   if (file.code == 200) {
    //     this.sizeForm.videoAddress = file.data.url;
    //   }
    // },

    //二维码格式校验
    QrFormat(file) {
      const ImgType = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (ImgType == "jpg" || ImgType == "png" || ImgType == "jpeg") {
        const isSize = new Promise(function (resolve, reject) {
          let width = 300;
          let height = 300;
          let _URL = window.URL || window.webkitURL;
          let image = new Image();
          image.onload = function () {
            let valid = image.width <= width && image.height <= height;
            valid ? resolve() : reject();
          };
          image.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        });
      } else {
        this.$message.error("请上传图片");
        return false;
      }
    },
    //二维码上传成功
    QrSuccess(file) {
      file.code == 200
        ? (this.qrtypeAddress = file.data.url)
        : this.$message({ message: "二维码上传异常!" });
      this.$forceUpdate();
    },
    //二维码上传失败
    QrError(response, file) {
      console.log("二维码上传失败");
    },
    //随机数产生
    productRandom(endTime, limit) {
      let dateArr = [];
      for (let i = 0; i <= endTime; i++) {
        i < limit ? (i = "0" + i) : (i = i.toString());
        let obj = {};
        obj.value = i;
        obj.label = i;
        obj.disabled = false;
        dateArr.push(obj);
      }
      return dateArr;
    },
    //时间日期处理
    forMatDate() {
      let startTime = null;
      let endTime = null;
      startTime =
        this.dateTime.beginyear +
        " " +
        this.dateTime.beginHour +
        ":" +
        this.dateTime.beginSecond;
      endTime =
        this.dateTime.endyear +
        " " +
        this.dateTime.endHour +
        ":" +
        this.dateTime.endSecond;
      this.sizeForm.startDate = startTime;
      this.sizeForm.endDate = endTime;
    },

    quit() {
      this.$router.go(-1);
    },

    // 根据id获取一条数据
    async getLiveData() {
      const data = await getexhdeta({ id: this.ids });
      if (data.data.code == 200) {
        //视频文件
        if (data.data.data.videoType == 1) {
          this.fileList.push({
            name: intercept(data.data.data.videoAddress),
            url: this.imgbaseUrl + data.data.data.videoAddress,
          });
        }
        //视频外链
        data.data.data.videoType == 2 &&
          (this.linktypeAddress = data.data.data.videoAddress);
        //二维码
        data.data.data.videoType == 3 &&
          (this.qrtypeAddress = data.data.data.videoAddress);

        this.sizeForm = data.data.data;
        this.flag = data.data.data.auditFlag;
        const beginYear = this.sizeForm.startDate.substring(0, 10);
        const beginHour = this.sizeForm.startDate.substring(11, 13);
        const beginminute = this.sizeForm.startDate.substring(14, 16);
        const endYear = this.sizeForm.endDate.substring(0, 10);
        const endHour = this.sizeForm.endDate.substring(11, 13);
        const endminute = this.sizeForm.endDate.substring(14, 16);
        this.dateTime.beginyear = beginYear;
        this.dateTime.beginHour = beginHour;
        this.dateTime.beginSecond = beginminute;
        this.dateTime.endyear = endYear;
        this.dateTime.endHour = endHour;
        this.dateTime.endSecond = endminute;
        this.sizeForm.auditFlag == 0
          ? (this.sizeForm.auditFlag = "审核通过")
          : "";
        this.sizeForm.auditFlag == -1
          ? (this.sizeForm.auditFlag = "未通过")
          : "";
        this.sizeForm.auditFlag == 2
          ? (this.sizeForm.auditFlag = "审核中")
          : "";
      }
    },

    //上传前校验
    videobeforeUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1); //获取文件后缀
      const extension = testmsg === "mp4";
      const extension2 = testmsg === "mov";
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是 mp4、mov格式!",
          type: "warning",
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 10MB!",
          type: "warning",
        });
        return false;
      }
    },

    //上传视频
    handlevideotypeAddress(res, file, fileList) {
      if (res.code == 200) {
        const { url } = res.data;
        this.videotypeAddress = url;
        this.fileList = fileList.slice(-1);

        this.$forceUpdate();
      }
    },

    // 点击弹窗播放视频
    playVideo(src) {
      let video;
      if (src.url) {
        //如果之前上传过视频
        video = src.url;
      } else if (src.response.code == 200) {
        if (src.response.data.url.indexOf("http") == -1) {
          src.response.data.url = this.imgbaseUrl + src.response.data.url;
        } else {
          src.response.data.url = src.response.data.url;
        }
        //上传后直接点击列表播放
        video = src.response.data.url;
      } else {
        return false;
      }
      var page = window.open();
      var html =
        "<body style='background:black'> <div style='width:80%;margin:auto;'> <video controls width='100%' height='90%' autoplay src='" +
        video +
        "'></video></div></body>";
      page.document.write(html);

      // var vdo = document.getElementById("videoPlay");
      // if (vdo.paused) {
      //   vdo.play();
      // } else {
      //   vdo.pause();
      // }
    },

    //开始结束时间限制
    clickStartTime() {
      this.startTimeOptions.disabledDate = (time) => {
        if (this.dateTime.beginyear) {
          if (time.getTime() > new Date(this.dateTime.beginyear).getTime()) {
            return true;
          }
          if (time.getTime() < Date.now() - 8.64e7) {
            return true;
          }
        } else {
          if (time.getTime() < Date.now() - 8.64e7) {
            return true;
          }
        }
      };
    },
    clickEndTime() {
      this.endTimeOptions.disabledDate = (time) => {
        if (this.dateTime.beginyear) {
          return (
            time.getTime() > Date.now - 8.64e7 ||
            time.getTime() <=
              new Date(this.dateTime.beginyear).getTime() - 8.64e7
          );
        } else {
          return time.getTime() < Date.now() - 8.64e7;
        }
      };
    },
  },

  // watch: {
  //   'sizeForm.videoType'(newVal, oldVal) {
  //     if (this.ids) {
  //       let address = this.sizeForm.videoAddress.slice(0, 4);

  //       if (newVal == '2' && address != 'http' && address != '') {
  //         this.$message({
  //           message: '视频外链请以"http"或"https://"开头!',
  //           type: 'warning',
  //         });
  //       }
  //     }
  //   },
  // },

  mounted() {
    this.getLiveData();
    this.dateTime.beginTimeHour = this.productRandom(23, 10);
    this.dateTime.beginTimeMinute = this.productRandom(59, 10);
    this.imgbaseUrl = forMat();
  },
};
</script>

<style lang="scss" scoped>
.live {
  box-sizing: border-box;
  padding: 18px 26px 0 0;
  background-color: white;
  .title {
    height: 55px;
    padding-left: 26px;
    border-bottom: 1px solid #e8e8e8;
    h3 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      cursor: pointer;
      span {
        margin-left: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        i {
          font-style: normal;
          color: red;
        }
      }
    }
  }
  .tixing {
    margin-left: 26px;
    margin-bottom: 40px;
    background: #f6f6f7;
    padding: 10px 30px;
    margin-top: 16px;
    h4 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff190c;
      line-height: 19px;
      margin-bottom: 9px;
      //margin-top: 26px;
    }
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 19px;
      i {
        font-style: normal;
        color: red;
      }
    }
  }
  .formdata {
    width: 650px;
    margin-top: 48px;
    // margin: 0 auto;
    padding-bottom: 30px;
    .tishi {
      margin-top: 5px;
      font-size: 12px;
      color: #999999;
    }
    .editor {
      width: 463px;
      height: 193px;
    }
    .shangchuan {
      width: 208px;
      height: 117px;
      border: 1px solid #e9e9e9;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f1f1f1;
      button {
        width: 94px;
        height: 28px;
        color: #666;
        background: white;
        border: 1px solid #e9e9e9;
      }
    }
    .button {
      margin-left: 38%;
      background: #006fb8;
    }
  }
}
p {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 19px;
}
//隐藏上传列表删除图标 提示
// ::v-deep .avatar-uploader {
//   .el-upload-list {
//     .el-upload-list__item:hover .el-icon-close {
//       display: none;
//     }

//     .el-upload-list__item.is-success.focusing {
//       .el-icon-close-tip {
//         display: none;
//       }
//     }
//   }
// }
</style>
<style scoped>
.ceshi {
  width: 100% !important;
}
.select {
  display: block;
  font-style: normal;
  width: 127px;
  height: 28px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: skyblue;
  /*// border: 1px solid red;*/
  width: 318px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.upload-demo >>> .el-upload-dragger {
  width: 225px;
  height: 173px;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px;
}

.upload-demo >>> .el-upload__text {
  width: fit-content;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  width: 102px;
  height: 28px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 27px;
}
.begin {
  display: flex;
  justify-content: space-between;
}
.mao {
  margin: 5px;
  position: relative;
  top: -5px;
  left: 5px;
}
.begin >>> .el-select {
  margin-left: 17px;
}
</style>
<style scoped>
.Addimg {
  width: 225px;
  height: 173px;
  margin-right: 20px;
}
.upload-demo >>> .el-upload-list__item {
  width: 225px;
  height: 173px;
}
/* .upload-demo >>> .avatar-uploader .el-upload-list .el-upload-list__item.is-success.focusing .el-icon-close-tip {
  　　display:none;
} */

.formdata >>> .el-button {
  padding: 7px 17px !important;
}
</style>
<style lang="scss" scoped>
//上传组件样式
.upload-logo {
  width: 363px;
  height: 209px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  &.qrcode {
    width: 240px;
    height: 135px;
    background: #f1f1f1;
  }
  &video {
    width: 200px;
    height: 140px;
    padding: 20px 20px;
  }
  img {
    position: absolute;
    right: 0;
    top: 0px;

    cursor: pointer;
    // z-index: 9999;
  }
  .upload-demo {
    align-self: center;
  }
}
video {
  max-width: 240px;
  height: 135px;
  z-index: 9999;
}
.del {
  z-index: 999px !important;
}
.tinymced {
  width: 450px;
  height: 300px;
  background: #000;
  position: absolute;
  z-index: 9;
  opacity: 0;
}
// .selectTxt{
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
// }
</style>
